@if(isBrowser) {

<ng-container *ngTemplateOutlet="fromtraffics ? extern : all"></ng-container>

<ng-template #all>
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{'Transfer' }}</span>
        <div class="tmp-section-body tmp-flexy">
            @if(!partner?.filters?.hideMitTransfe) {
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="mittransfer" multilang (click)="selectmittransfer()"
                matRipple>{{'mit Transfer' }}</button>
            }
            @if(!partner?.filters?.hideOhneTransfer) {
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="ohnetransfer"
                (click)="selectohnetransfer()" matRipple>{{'ohne Transfer' }}</button>
            }
        </div>
        <div class="tmp-section-body tmp-flexy">
            @if(!partner?.filters?.hideMietwagen) {
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="mietwagen" multilang (click)="selectmietwagen()"
                matRipple>{{'Mietwagen' }}</button>
            }
            @if(!partner?.filters?.hideZugzumFlug) {
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="zugtumflug" multilang (click)="selectzugtumflug()"
                matRipple>{{'Zug zum Flug' }} *</button>
            }
        </div>
    </div>
</ng-template>

<ng-template #extern>
    @if(inclusiveList?.length > 0) {
    <div class="tour-title-wrapper">
        <span multilang class="tour-title">{{'Transfer' }}</span>
    </div>

    <div class="tour-wrapper">
        <ng-container *ngFor="let item of inclusiveList">
            <button class="tour-item-wrapper-ext" (click)="selected(item.code)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span multilang class="tour-item-name-ext">{{item.name }}</span>
                    <span multilang class="bestprcit">{{'ab' }} {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
        </ng-container>
    </div>
    }
</ng-template>
}